module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible || _vm.closing) ? _c('div', {
    staticClass: "popup-overlay",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('div', {
    staticClass: "popup-area"
  }, [_c('div', {
    class: ['popup-content', {
      'slide-down': _vm.closing
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "popup-header"
  }, [_c('span', {
    staticClass: "close-btn"
  }, [_c('button', {
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _c('span', {
    staticClass: "header-info"
  }, [_vm._v("You are missing out on these perks!")])]), _vm._v(" "), _c('div', {
    staticClass: "containerdashed alt"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, _vm._l((_vm.perks), function(perk, index) {
    return _c('div', {
      key: index,
      staticClass: "perk"
    }, [_c('img', {
      attrs: {
        "src": perk.icon,
        "alt": perk.title
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(perk.title))])])
  })), _vm._v(" "), _c('button', {
    staticClass: "membership-btn",
    on: {
      "click": _vm.purchaseMembership
    }
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderForMemberShipBanner && _vm.bannerPlaceHolderForMemberShipBanner.tag_text))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b81c3b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/membershipPopUpBanner.vue
// module id = 2463
// module chunks = 14